<div class="row">
  <div class="col-12 col-md-6 order-2 order-md-1">
    <h4 class="h4 mb-3">{{ loadedData().routerName }}</h4>

    @if (loadedData().beschreibung) {
      <p class="mb-4">{{ loadedData().beschreibung }}</p>
    }

    @if (loadedData().aufzaehlungspunkte && loadedData().aufzaehlungspunkte.length > 0) {
      <ul class="mb-4">
        @for (punkt of loadedData().aufzaehlungspunkte; track $index) {
          <li>{{ punkt }}</li>
        }
      </ul>
    }

    @if (loadedData().preisTexte) {
      <p class="h6 mb-4">{{ loadedData().preisTexte }}</p>
    }
  </div>
  <div class="col-12 col-md-6 order-1 order-md-2 d-flex justify-content-center align-items-start">
    <div class="w-100">
      <img [src]="loadedData().routerImage || '/assets/img/mvno/FritzBox.jpg'" alt="Router" class="img-fluid" />
    </div>
  </div>
</div>
<div class="row">
  <mwe-button class="mt-4" category="primary" [labelKey]="'infoIconPopup.close' | translate" (clicked)="onCloseClick.emit()"></mwe-button>
</div>
